import { useState } from 'react';
import PropTypes from 'prop-types';

import CancelPlan from 'features/account/my-plan/CancelPlan';
import HardCancel from 'features/account/my-plan/HardCancel';
import PausePlan from 'features/account/my-plan/PausePlan';
import { Alert } from 'honeydew/Alert';
import Modal from 'honeydew/Modal';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import { closeModal } from 'utils/globalUtils';

import { CancelPlanPlusMembershipInfoModule } from '../CancelPlanPlusMembershipInfoModule';

function CancelationModal({
    account,
    cancelationModal,
    cancelationStep,
    setCancelationModal,
    setCancelationStep,
    setSuccess,
    subscription,
}) {
    const { inPlusMembershipTreatment, membership, trial } = useAccountPlusMembershipHook();

    const [error, setError] = useState('');
    const [showPlusMembershipActiveModal, setShowPlusMembershipActiveModalsetError] = useState(false);

    const closeCancelationModal = () => {
        if (cancelationStep === 'cancel' && window.isNativeApp) {
            window.ReactNativeWebView?.postMessage(JSON.stringify({ reload: true }));
        }
        closeModal(setCancelationModal);
        setCancelationStep('pause');
    };

    return (
        <Modal open={cancelationModal} onClose={closeCancelationModal}>
            {error !== '' && (
                <div className="my-20 md:px-40">
                    <Alert variant="error">{error}</Alert>
                </div>
            )}
            {cancelationStep === 'pause' && (
                <PausePlan
                    setError={setError}
                    closeCancelationModal={closeCancelationModal}
                    setCancelationStep={setCancelationStep}
                    setSuccess={setSuccess}
                    subscription={subscription}
                />
            )}
            {cancelationStep === 'cancel' && !showPlusMembershipActiveModal && (
                <CancelPlan
                    account={account}
                    setError={setError}
                    closeCancelationModal={() => {
                        if (inPlusMembershipTreatment && (membership || trial)) {
                            setShowPlusMembershipActiveModalsetError(true);
                        } else {
                            closeCancelationModal();
                        }
                    }}
                    setSuccess={setSuccess}
                    subscription={subscription}
                />
            )}
            {cancelationStep === 'cancel' && showPlusMembershipActiveModal && <CancelPlanPlusMembershipInfoModule />}
            {cancelationStep === 'hard-cancel' && (
                <HardCancel
                    setError={setError}
                    closeCancelationModal={closeCancelationModal}
                    subscription={subscription}
                />
            )}
        </Modal>
    );
}

CancelationModal.propTypes = {
    account: PropTypes.shape({}),
    cancelationModal: PropTypes.bool.isRequired,
    setCancelationModal: PropTypes.func.isRequired,
    setSuccess: PropTypes.func.isRequired,
    subscription: PropTypes.shape({}),
};

CancelationModal.defaultProps = {
    account: {},
    subscription: {},
};

export default CancelationModal;
